/*
 * @Author: ke wen
 * @Date: 2021-01-26 16:03:24
 * @LastEditTime: 2021-03-13 11:25:56
 * @LastEditors: LastEditors
 * @Description: 全局公用方法
 * @FilePath: /dangjia-admin/src/utils/fun.js
 */

// import Cookies from 'js-cookie'
// import Vue from 'vue'
import Storage from './storage'
import route from '@/router/index'
import { getCityList, searchCityList, getAppList, upDocument, createSession, handshakeClientAndServer, renewSession, testEncrypt } from '@/api/public'
import { Toast } from 'vant'
import jsrsasign from 'jsrsasign'
import { createClientKey } from '@/utils/rsa'
import store from '@/store'
import { h5BaseUrl,pointsBaseUrl } from "./urlConfig";


let upFlag = true, //访问登陆页面状态 防止重复进入
    queryNum = 0, //当前请求的数据标识 会累加   
    waitingQueryObj = {}, //等待请求发出状态对象-用于监听{state1:true,state2:true,...}
    createSessionState = false; //创建请求状态 为true时后续进入的所有请求进入监听状态

// 创建会话
function onCreateSession() {
    return new Promise(async (resolve, reject) => {
        createSessionState = true //表示正在创建会话
        let keyList = await createClientKey()
        clearSession() // 清除已过期会话内容
        Storage.set('keyList', keyList)
        let res = await createSession() //创建会话
        Storage.set('sessionData', res.data)
        let param = {
            clientPublicKey: keyList.public
        }
        let wRes = await handshakeClientAndServer(param) //握手
        if (wRes.data && wRes.data.aesPassword) {
            Storage.set('aesPassword', wRes.data.aesPassword)
        }
        resolve()
        // 续约完成告诉等待中的接口
        setTimeout(() => {
            Object.getOwnPropertyNames(waitingQueryObj).forEach((key) => {
                waitingQueryObj[key] = false
            })
            createSessionState = false
        }, 0)
    })
}
//续约
function onHandshakeClientAndServer() {
    return new Promise(async (resolve, reject) => {
        createSessionState = true //表示正在创建会话
        let keyList = await createClientKey()
        // clearSession() // 清除已过期会话内容
        Storage.set('keyList', keyList)
        let res = await renewSession()
        Storage.set('sessionData', res.data)
        let param = {
            clientPublicKey: keyList.public
        }
        let wRes = await handshakeClientAndServer(param)
        if (wRes.data && wRes.data.aesPassword) {
            Storage.set('aesPassword', wRes.data.aesPassword)
        }
        resolve()

        // 续约完成告诉等待中的接口
        setTimeout(() => {
            Object.getOwnPropertyNames(waitingQueryObj).forEach((key) => {
                waitingQueryObj[key] = false
            })
            createSessionState = false
        }, 0)

    })
}

// 清除会话字段
function clearSession() {
    if (Storage.get('aesPassword')) {
        Storage.remove('aesPassword')
    }
    if (Storage.get('sessionData')) {
        Storage.remove('sessionData')
    }
    if (Storage.get('keyList')) {
        Storage.remove('keyList')
    }
}
//补0
function repair(i) {
	if (i >= 0 && i <= 9) {
		return "0" + i;
	} else {
		return i;
	}
}
// 获取当前时间
function getCurrentTime() {
	var date = new Date() //当前时间
	var year = date.getFullYear() //返回指定日期的年份
	var month = repair(date.getMonth() + 1) //月
	var day = repair(date.getDate()) //日
	var hour = repair(date.getHours()) //时
	var minute = repair(date.getMinutes()) //分
	var second = repair(date.getSeconds()) //秒

	//当前时间 
	var curTime = year + "-" + month + "-" + day +
		" " + hour + ":" + minute + ":" + second
	return curTime
}
var ua = navigator.userAgent;
var isAndroid = (ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1);//安卓
var isiOS = (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)); //ios终端
const fun = {
    // 公钥
    // PublicKey,
    // 私钥
    // PrivateKey,
    onBack: () => { //  返回上一页方法
        route.back()
    },
    onMsg: (res, fun) => {
        console.log(res)
        if (res.code == '00000000') {
            return fun(res)
        } else {
            Toast(res.msg)
        }
    },
    // 处理金额
    disposeMoney(form, key) {
        let val = form[key].replace(/(^\s*)|(\s*$)/g, "");
        if (!val) return form[key] = "";
        val = val.replace(/[^\d.]/g, "");
        val = val.replace(/^\./g, "");
        val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
        form[key] = val;
    },
    // 处理数值
    disposeNum(form, key) {
        form[key] = form[key].replace(/[^\d]/g, "")
    },
    // 乘法精度计算
    NumberMul(arg1, arg2) {
        var m = 0;
        var s1 = arg1.toString();
        var s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length;
        } catch (e) { }
        try {
            m += s2.split(".")[1].length;
        } catch (e) { }

        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },

    formatRichText(html) {
        if(!html){
            return ''
        }
		let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
            if(match){
                match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
                match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
                match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
                return match;
            }
			
			
		});
		newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
			match = match.replace(/width:[^;]+;/gi, 'width:100%;').replace(/width:[^;]+;/gi,
				'width:100%;');
			return match;
		});
		newContent = newContent.replace(/<br[^>]*\/>/gi, '');
		newContent = newContent.replace(/\<img/gi,
			'<img style="width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"');
		newContent = newContent.replace(/\<p/gi,
			'<p style="word-wrap:break-word;word-break: break-all;"');	
		return newContent;
	},
    upAllDocument: async (formDataList) => {
        let errorIndex = [], successList = []
        for (const [index, formData] of formDataList.entries()) {
            let { file, objectKey, contentType, xobsAcl, policy, signature, accessKey, action } = formData
            if (action) {  //没有返回action 证明图片已经存在obs里面了
                let param = new FormData()
                param.append('key', objectKey)
                param.append('content-type', contentType)
                param.append('x-obs-acl', xobsAcl)
                param.append('policy', policy)
                param.append('signature', signature)
                param.append('accessKeyId', accessKey)
                param.append('file', file)
                let res = await upDocument(action, param)
                console.log(res)
                if (res >= 200 && res <= 300) {
                    successList.push(formData)
                } else {
                    errorIndex.push(index + 1)
                }
            } else {
                successList.push(formData)
            }

        }
        return { successList: successList, errorIndex: errorIndex }
    },

    // 会话处理方法
    disposeSession() {
        return new Promise(async (resolve, reject) => {
            let sessionData = Storage.get('sessionData')
            let aesPassword = Storage.get('aesPassword')
            if (sessionData && aesPassword) { //密钥存在
                let renewTime = new Date(sessionData.renewTime).getTime() //建议续约时间
                let expireTime = new Date(sessionData.expireTime).getTime() //失效时间
                let date = new Date().getTime()
                if (date >= renewTime && date < expireTime) { //当前时间大于建议续约时间还未失效
                    if (createSessionState) { //当前有请求进入续约会话 其他请求来此等待
                        Object.defineProperty(waitingQueryObj, 'state' +
                            queryNum++, { //监听对应属性 属性值变为false 则输出等待中的请求
                            get: () => {
                                return createSessionState
                            },
                            set: (value) => {
                                createSessionState = value
                                if (!value) {
                                    resolve()
                                }
                            }
                        });
                    } else { //当前无请求进入续约会话 直接去续约 createSessionState = true 续约的时候会让后续请求进入等待
                        await onHandshakeClientAndServer()
                        resolve()
                    }
                } else if (date > expireTime) { // 会话已过期
                    if (createSessionState) { //当前有请求进入续约会话 其他请求来此等待
                        Object.defineProperty(waitingQueryObj, 'state' +
                            queryNum++, { //监听对应属性 属性值变为false 则输出等待中的请求
                            get: () => {
                                return createSessionState
                            },
                            set: (value) => {
                                createSessionState = value
                                if (!value) {
                                    resolve()
                                }
                            }
                        });
                    } else {
                        await onCreateSession()
                        resolve()
                    }
                } else { //会话有效
                    resolve()
                }
            } else { //密钥不存在
                if (createSessionState) { //当前有请求进入续约会话 其他请求来此等待
                    Object.defineProperty(waitingQueryObj, 'state' +
                        queryNum++, { //监听对应属性 属性值变为false 则输出等待中的请求
                        get: () => {
                            return createSessionState
                        },
                        set: (value) => {
                            createSessionState = value
                            if (!value) {
                                resolve()
                            }
                        }
                    });
                } else {
                    await onCreateSession()
                    resolve()
                }
            }
        })
    },
     base64ToFile(base64, fileName) {
        let arr = base64.split(",");
        console.log(arr[0].match(/:(.*?);/),'-----------')
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], fileName, { type: mime });
    },


    // sign
    getCode: (txt) => {
        // 创建RSAKey对象
        txt = jsrsasign.b64tohex(txt)
        var rsa = new jsrsasign.RSAKey();
        //因为后端提供的是pck#8的密钥对，所以这里使用 KEYUTIL.getKey来解析密钥
        var k = `-----BEGIN RSA PRIVATE KEY-----${Storage.get('keyList').private}-----END RSA PRIVATE KEY-----`
        // 将密钥转码
        rsa = jsrsasign.KEYUTIL.getKey(k);
        // 创建Signature对象，设置签名编码算法
        var sig = new jsrsasign.KJUR.crypto.Signature({ "alg": "SHA256withRSA" });
        // 初始化
        sig.init(rsa)
        // 传入待加密字符串
        sig.updateHex(txt)
        // 生成密文
        var sign = jsrsasign.hextob64(sig.sign());
        // 对加密后内容进行URI编码
        // sign = encodeURIComponent(sign);
        //把参数与密文拼接好，返回
        // var params = newStr + '&sign=' + sign;
        return sign
    },
    //判断当前环境
    checkPlatform: () => {
        let platform = []
        if (/android/i.test(navigator.userAgent)) {
            platform.push('android')
        }
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            platform.push('ios')//这是iOS平台下浏览器
        }
        if (/Linux/i.test(navigator.userAgent)) {
            platform.push('Linux');//这是Linux平台下浏览器
        }
        if (/Linux/i.test(navigator.platform)) {
            platform.push('Linux');//这是Linux操作系统平台
        }
        if (/MicroMessenger/i.test(navigator.userAgent)) {
            platform.push('mini');//这是微信平台下浏览器
        }
        if (/WeiBo/i.test(navigator.userAgent)) {
            platform.push('wb');//这是微博平台下浏览器
        }
        if (/MQQBrowser/i.test(navigator.userAgent)) {
            platform.push('qq');//这是qq平台下浏览器
        }
        if (/UCBrowser/i.test(navigator.userAgent)) {
            platform.push('uc');//这是uc平台下浏览器
        }
        return platform
    },

    // 价格展示筛选
    filterShowPrice: (marketingPrice, svipPrice, activityPrice) => {
        if (activityPrice) {
            return { type: 'activityPrice', price: activityPrice }
        } else if (svipPrice) {
            return { type: 'svipPrice', price: svipPrice }
        } else {
            return { type: 'marketingPrice', price: marketingPrice }
        }
    },

    // 统计封装 eventId 事件id param:额外参数 pageParam:终端参数
    trackEvent: (eventId, param = {}, pageParam = {}) => {
        // 创建公共参数
        let publicParams = {
            user_id: '',
            event_time: getCurrentTime(),
            login_status: pageParam.accessToken ? 1 : 0,
            application_version: store.getters.appVerName,
            operating_system: isiOS?'ios':isAndroid?'android':'',
            city_name: pageParam.cityCode||'未获取到城市',
            url_path: encodeURIComponent(window.location.href)
        }
        if ((process.env.VUE_APP_ENV || process.env.NODE_ENV) != 'production') {
			return
		}
        window.aplus_queue.push({
            action: 'aplus.record',
            arguments: [eventId, 'CLK', {
                ...publicParams,
                ...param
            }]
        });
    },
    clientXY(){
        if(window.innerHeight !== undefined){
            return {
                width: window.innerWidth,
                height: window.innerHeight
            }
        }else if(document.compatMode === "CSS1Compat"){
            return {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        }else{
            return {
                width: document.body.clientWidth,
                height: document.body.clientHeight
            }
        }
    },
    // getParameterByName(name) {
    //     let urlParams = new URLSearchParams(window.location.search);
    //     console.log(urlParams,'urlParams')
    //     return urlParams.get(name);
    // },
    getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    // 解析原生拼到链接上的 param，避免 JSON 不合法直接白屏
    parsePageParam(param) {
        if (param && typeof param === 'object') {
            return param;
        }
        let raw = param;
        if (!raw) {
            raw = fun.getParameterByName('param');
        }
        if (!raw || typeof raw !== 'string') {
            return {};
        }
        const tryParse = (str) => {
            try {
                return JSON.parse(str);
            } catch (e) {
                return null;
            }
        };
        let data = tryParse(raw);
        if (data) {
            return data;
        }
        try {
            data = tryParse(decodeURIComponent(raw));
            if (data) {
                return data;
            }
        } catch (e) {}
        // 兼容漏逗号：{"appType":"artisan_android""accessToken":"xxx"}
        const fixed = raw.replace(/"\s*"([A-Za-z_])/g, '","$1');
        data = tryParse(fixed);
        if (data) {
            return data;
        }
        try {
            data = tryParse(decodeURIComponent(fixed));
            if (data) {
                return data;
            }
        } catch (e) {}
        return {};
    },
    onGetCmdToPage: (cmd, param = '') => {
		
		if (!param) return
		let pageUrl = '',
			urlParam = JSON.parse(param);
		switch (cmd) {
            case 'C0000':
                pageUrl = urlParam.url+'&param='+fun.getParameterByName('param');
                break;
			case 'C2001'://裂变活动
				pageUrl = h5BaseUrl+'sharedFissionActivity?activityId='+urlParam.activityId+'&param='+fun.getParameterByName('param')
				break;
            case 'C2002'://活动列表
                pageUrl = h5BaseUrl+'threeSharingActivities/activitiesList?id='+urlParam.activityId+'&param='+fun.getParameterByName('param')
                break;  
            case 'C2003'://转单得积分活动
                pageUrl = pointsBaseUrl+'activity/transferOrderActivity?id='+urlParam.activityId+'&param='+fun.getParameterByName('param')
                break;  
            case 'C2004'://邀请好友得积分活动
                pageUrl = pointsBaseUrl+'activity/inviteFriendsActivity?id='+urlParam.activityId+'&param='+fun.getParameterByName('param')
                break; 
                                        
			default:
				break;
		}
		if (pageUrl) {
			window.location.href = pageUrl
		}
    },

    // 滚动工具函数
    scrollUtils: {
        // 获取页面滚动百分比（基于屏幕高度倍数）
        getScrollPercent() {
            // 获取页面滚动距离
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

            // 获取视窗高度
            const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

            // 计算滚动百分比：滚动距离 / 视窗高度 * 100
            // 例如：滚动1个屏幕高度 = 100%，滚动2个屏幕高度 = 200%
            return Math.round((scrollTop / windowHeight) * 100);
        },

        // 获取传统滚动百分比（0-100%，基于文档总高度）
        getTraditionalScrollPercent() {
            // 获取页面滚动距离
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

            // 获取页面总高度
            const documentHeight = Math.max(
                document.body.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.clientHeight,
                document.documentElement.scrollHeight,
                document.documentElement.offsetHeight
            );

            // 获取视窗高度
            const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

            // 计算可滚动距离
            const scrollableDistance = documentHeight - windowHeight;

            // 计算滚动百分比
            if (scrollableDistance > 0) {
                return Math.min(100, Math.max(0, Math.round((scrollTop / scrollableDistance) * 100)));
            } else {
                return 0;
            }
        },

        // 监听滚动事件并更新百分比
        watchScroll(callback, throttleTime = 16) {
            let ticking = false;

            const handleScroll = () => {
                if (!ticking) {
                    requestAnimationFrame(() => {
                        const percent = this.getScrollPercent();
                        callback(percent);
                        ticking = false;
                    });
                    ticking = true;
                }
            };

            // 添加节流优化
            let lastCall = 0;
            const throttledHandleScroll = () => {
                const now = Date.now();
                if (now - lastCall >= throttleTime) {
                    lastCall = now;
                    handleScroll();
                }
            };

            window.addEventListener('scroll', throttledHandleScroll, { passive: true });

            // 返回清理函数
            return () => {
                window.removeEventListener('scroll', throttledHandleScroll);
            };
        },

        // 获取滚动相关信息
        getScrollInfo() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            const documentHeight = Math.max(
                document.body.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.clientHeight,
                document.documentElement.scrollHeight,
                document.documentElement.offsetHeight
            );
            const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            const scrollableDistance = documentHeight - windowHeight;

            return {
                scrollTop,
                documentHeight,
                windowHeight,
                scrollableDistance,
                percent: this.getScrollPercent(), // 基于屏幕高度倍数的百分比
                traditionalPercent: this.getTraditionalScrollPercent() // 传统0-100%百分比
            };
        }
    },

}
export default fun
